import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../services/api.service";

@Component({
  selector: 'app-searchciudades',
  templateUrl: './searchciudades.page.html',
  styleUrls: ['./searchciudades.page.scss'],
})
export class SearchciudadesPage implements OnInit {

  constructor(
    public api:ApiService
  ) { }

  ngOnInit() {
  }

}
